// fetchMeLivestreams.js
'use strict';
import 'isomorphic-fetch';
import parseLinkHeader from 'parse-link-header';

import getMeData from '../selector/getMeData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import objectifyArrayById from '../resource/objectifyArrayById.js';

import {
  ADD_LIST_ITEMS,
  SET_LIST_ITEMS,
  MERGE_OPERATION_DATA,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch me livestreams
 * @kind action
 * @param {number} {[page = 1]} - page number.
 * @param {number} {[limit = 10]} - page size.
 * @return {Promise} Action promise.
 */
const fetchMeLivestreams =
  ({ page = 1, limit = 10 } = {}) =>
  async (dispatch, getState) => {
    const networkingSelectPath = ['fetch', 'me', 'livestream', page];
    const token = getMeData(getState(), 'token');
    if (!token) {
      return dispatch({ type: '' });
    }
    const fetchOptions = {
      method: 'GET',
      headers: {
        ...getHeaders(),
        Authorization: `Bearer ${token}`,
      },
    };
    const fetchUrl = getResourceUrl({ endpoint: '/streams/me' });
    fetchUrl.searchParams.set('limit', limit);
    fetchUrl.searchParams.set('page', page);
    dispatch({
      type: SET_NETWORKING_FETCHING,
      payload: { selectPath: networkingSelectPath },
    });
    try {
      let response = await fetch(fetchUrl.href, fetchOptions);
      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl,
        });
      }
      const payload = await response.json();
      const etag = response.headers.get('etag');
      const lastEtag = getNetworkingData(
        getState(),
        networkingSelectPath,
        'etag'
      );
      if (etag && lastEtag === etag) {
        return dispatch({
          type: SET_NETWORKING_SUCCESS,
          payload: { selectPath: networkingSelectPath, etag },
        });
      }
      const totalCount = parseInt(response.headers.get('x-total-count'), 10);
      const links = parseLinkHeader(response.headers.get('Link'));
      const nextPage = links && links.next && parseInt(links.next.page, 10);
      const lastPage = links && links.last && parseInt(links.last.page, 10);
      const itemIds = payload.map(({ id }) => id);
      const livestreamObject = objectifyArrayById({
        array: payload.map(
          ({
            id: sessionId,
            startTime: startUnixTimestamp,
            endTime: endUnixTimestamp,
            summary,
          }) => ({
            id: sessionId,
            startUnixTimestamp,
            endUnixTimestamp,
            summary,
          })
        ),
      });
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['me', 'livestream'],
          data: livestreamObject,
        },
      });
      dispatch({
        type: page === 1 ? SET_LIST_ITEMS : ADD_LIST_ITEMS,
        payload: {
          selectPath: ['me', 'livestream'],
          itemIds,
          totalCount,
          nextPage,
          lastPage,
        },
      });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath: networkingSelectPath, etag },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath: networkingSelectPath, error },
      });
    }
  };

export default fetchMeLivestreams;
